import * as types from './actionType';
import asyncActionCreator from '../../../utils/asyncActionCreator';
import API from '../../../API/api'

const getMissionListAsyncRequest = (data) => ({
    type: types.GET_TASK_LIST_REQUEST,
    payload: data
});

const getMissionListAsyncSuccess = (data) => ({
    type: types.GET_TASK_LIST_SUCCESS,
    payload: data
});

const getMissionListAsyncFailure = (error) => ({
    type: types.GET_TASK_LIST_FAILURE,
    payload: error
});
export const getMissionList = (data,callback,error) => asyncActionCreator(
    API.GET_TASK_LIST,
    getMissionListAsyncRequest,
    getMissionListAsyncSuccess,
    getMissionListAsyncFailure,
    'POST',
    data,
    callback,
    error
);
export const setCurrent = (error) => ({
    type: types.SET_MISSION_LIST_CURRENT,
    payload: error
});





// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/action.js